module.exports = __webpack_public_path__ + "img/splash.8b7a116d.svg";